import { CaretLeftIcon, CaretRightIcon } from '@radix-ui/react-icons'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

interface Props {
  weeksAgo: number
  setWeeksAgo: (weeksAgo: number) => void
  size?: 'sm' | 'xs'
}

const WeekSwitcher = ({ weeksAgo, setWeeksAgo, size = 'sm' }: Props) => {
  return (
    <div
      className={cn(
        'flex items-center justify-between gap-1 w-46',
        size === 'xs' ? 'h-8' : '',
      )}
    >
      <Button
        variant='outline'
        size={size}
        onClick={() => setWeeksAgo(weeksAgo + 1)}
      >
        <CaretLeftIcon />
      </Button>
      {weeksAgo === 0 ? (
        <span className={size === 'xs' ? 'text-xs' : ''}>This week</span>
      ) : (
        <div className='flex items-center gap-2 grow'>
          <Input
            type='number'
            className={`text-center ${
              size === 'xs' ? 'w-11 h-5 text-xs' : 'w-12 h-9'
            }`}
            value={weeksAgo}
            onChange={(e) => setWeeksAgo(Number(e.target.value))}
          />
          <div className='flex flex-col text-xs items-center grow whitespace-nowrap'>
            <span>{weeksAgo === 1 ? 'week' : 'weeks'}</span>
            <span>ago</span>
          </div>
        </div>
      )}
      <Button
        disabled={weeksAgo === 0}
        variant='outline'
        size={size}
        onClick={() => setWeeksAgo(weeksAgo - 1)}
      >
        <CaretRightIcon />
      </Button>
    </div>
  )
}

export default WeekSwitcher
